import React from "react";
import { AdditionalEligibilityRuleContainer } from "../../../containers";

const AdditionalEligibilityRule = (props) => {
  return <AdditionalEligibilityRuleContainer {...props} />;
};

export default AdditionalEligibilityRule;
